/**
 * App shell component — header, tab-nav, panel host.
 * Migration target: S1 head/meta + S2 shell layout + S23 panel host.
 * Maps to MTSS2RTI.html S1 (top–5,173) + S2 static shell + S23 panel container.
 * Roadmap note: Shell hosts tab0–tab8 panels via TAB_PANEL_MAP mapping.
 * TODO: Implement React Shell component with header, nav tabs, panel outlet.
 * Until then the shell is a pass-through panel host — it must not swallow the
 * routed content it is handed (App.tsx mounts <Routes> inside it).
 */
import type { ReactNode } from 'react';

export const Shell = ({ children }: { children: ReactNode }) => <>{children}</>;
